import { CombinedIncome } from "./types/income";

export const incomeTypeMap = {
  self_employment: "Self-employment",
  employment: "Employment",
  other: "Other",
  housing_assistance: "Housing assistance",
  offer_letter: "Offer letter"
};

export const verificationSourceType = {
  bank: "Bank account",
  paystub: "Paystub",
  payroll: "Payroll provider",
  offer_letter: "Offer letter"
};

export const getVerificationTitleName = (income: CombinedIncome) => {
  switch (income.type) {
    case "employment":
      return income.additional_data.company_name || "Employment";
    case "self_employment":
      return income.additional_data.company_name || "Self-employment";
    case "other":
      return income.additional_data.paid_from || "Other";
    case "housing_assistance":
      return "Housing assistance";
    case "offer_letter":
      return income.additional_data?.company_name || "Offer letter";
    default:
      return "Unknown income type";
  }
};

export const getIncomeJobName = (income: CombinedIncome) => {
  if (!income.additional_data) return "Unknown";

  if (
    "company_name" in income.additional_data &&
    income.additional_data.company_name
  )
    return income.additional_data.company_name;

  if ("job_title" in income.additional_data && income.additional_data.job_title)
    return income.additional_data.job_title;

  if (
    "description" in income.additional_data &&
    income.additional_data.description
  )
    return income.additional_data.description;

  if ("paid_from" in income.additional_data && income.additional_data.paid_from)
    return income.additional_data.paid_from;

  return "Unknown";
};

export const getMonthlyAmount = (
  amountCents: number,
  payPeriod: string
): number => {
  switch (payPeriod) {
    case "weekly":
      return (amountCents * 52) / 12;
    case "bi_weekly":
      return (amountCents * 26) / 12;
    case "annually":
      return amountCents / 12;
    default:
      return amountCents; // Assuming monthly if not specified
  }
};
